/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:27
 * @LastEditTime: 2020-01-09 17:46:04
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\networkResource\featuredResource\robot\robot_router.js
 * @Description:
 */
'use strict';
angular.module('resCenRobotRouterModule', []).config([
    '$stateProvider',
    function($stateProvider) {
        $stateProvider
            .state('front.networksource.featuredresource.robot.resource', {
                url: '/resource?typename&nodeid&nodename',
                views: {
                    'networksource@front.networksource.featuredresource.robot': {
                        templateUrl: './networkResource/featuredResource/robot/robot_main_tpl.html',
                        controller: 'resCenRobotCtrl',
                    },
                },
            })
            .state('front.networksource.featuredresource.robot.quickpreview', {
                url: '/quickpreview?typename&nodeid&nodename&guid',
                views: {
                    'networksource@front.networksource.featuredresource.robot': {
                        templateUrl: './networkResource/featuredResource/robot/quickPreview/main_tpl.html',
                        controller: 'robotQuickPreviewCtrl',
                    },
                },
            });
    },
]);
